import React from "react";
import {IIsOnTimeDurationColumnProps} from '../interfaces/ITimeTrackingRecordProps'


const IsOnTimeDurationColumn: React.FC<IIsOnTimeDurationColumnProps> = ({
  record,
  formatTimerDuration,
  isOnTime,
  LateClockIcon,
  date
}) => {
  if (!record) return null;
  const { duration, endTime, startTime, updatedAt } = record;
  // console.log("Date and record",date ,record)
  const showLateIcon =
    (endTime && updatedAt) || (startTime && updatedAt)
      ? !isOnTime(updatedAt, startTime, endTime, date)
      : false;

  return (
    <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
      {duration ? formatTimerDuration(duration) : ""}
      {showLateIcon && (
        <img
          src={LateClockIcon}
          alt="LateClockIcon"
          width={25}
          height={25}
          style={{ paddingLeft: "5px" }}
        />
      )}
    </span>
  );
};

export default IsOnTimeDurationColumn;